import React from 'react'
import "./ecommerce.scss"
import CardFraudList from './sections/cardFraudList'
import DigitalFastEfficient from './sections/digitalFastEfficient'
import EcommerceAlwaysEfficient from './sections/ecommerceAlwaysEfficient'
import Letsgo from "../connectors/letsgo"

function Ecommerce() {
  return (
    <div className='container-ecommerce'>
        <div className="section-ecommerce-always-efficient">
            <EcommerceAlwaysEfficient />
        </div>
        <div className="section-digital-fast-efficient">
          <DigitalFastEfficient />
        </div>
        <div className="section-card-fraud-list">
          <CardFraudList />
        </div>
        <div className="section-letsgo">
          <Letsgo />
        </div>
    </div>
  )
}

export default Ecommerce